/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".vs-thumbnail{width:150px;height:150px;position:relative}.vs-thumbnail:hover .vs-btn-thumbnail{display:inline-block}.vs-btn-thumbnail{display:none;position:absolute;bottom:0;height:30px;width:100%;opacity:.5;background:#000;left:0;cursor:pointer}.vs-btn-thumbnail span{line-height:30px;color:#fff}.text-center{text-align:center!important}a.text-danger,a.text-danger:hover{color:#a20000!important;font-weight:600;line-height:28px}"];
export { styles as styles };
